<template>
    <div class="matermanage_box">
        <Search @search='pageInfor.pageNo=1;showMaterialsByCondition()' @reset="pageInfor.pageNo=1;reset()">
            <div class="search_box" slot="one">
                <div class="search_items">
                    &nbsp;&nbsp;素材 ID：
                    <input v-model.trim="searchParams.materialId" type="text" class="public_input">
                </div>
                <div class="search_items">
                    标题：
                    <input v-model.trim="searchParams.title" type="text" class="public_input">
                </div>
                <div class="search_items">
                    所属栏目：
                    <Select class="search_select" v-model="searchParams.belongColumn">
                        <Option :value="item.value" v-for="item,index in columnsList" :key="index">{{item.label}}</Option>  
                    </Select>
                </div>
                <div class="search_items">
                    创建时间：
                    <DatePicker type="date" v-model.trim="searchParams.createdTimeStart" placeholder="选择日期" class="search_date"></DatePicker>
                    --
                    <DatePicker type="date" v-model.trim="searchParams.createdTimeEnd" placeholder="选择日期" class="search_date"></DatePicker>
                </div>
            </div>
        </Search>
        <ul class="matterManage_tab">
            <li @click="pageInfor.pageNo=1;searchParams.state=null;showMaterialsByCondition()" :class="{'active':searchParams.state==null}">全部</li>
            <li @click="pageInfor.pageNo=1;searchParams.state=0;showMaterialsByCondition()" :class="{'active':searchParams.state===0}">未发布</li>
            <li @click="pageInfor.pageNo=1;searchParams.state=1;showMaterialsByCondition()" :class="{'active':searchParams.state==1}">已发布</li>
            <!-- <li @click="searchParams.state=3;showMaterialsByCondition()" :class="{'active':searchParams.state==3}">已撤回</li> -->
        </ul>
        <div class="matterManage_btn_box">
            <router-link :to="{path:'/matterManage/matter_created'}" v-if="buttons.indexOf('30014001001')!='-1'">
                <div class="matterManage_btn">发布新素材</div>
            </router-link>
        </div>
        <Table :columns='tableColumns' :data='dataList.records'></Table>
        <div class="page">
            <Page :total="dataList.totalCount" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageInfor.pageSize" :current="pageInfor.pageNo" show-elevator show-sizer placement='top' size='small'></Page>
        </div>
        <!-- 日志弹框 -->
        <Modal v-model="logModal.flag" title="日志" class="publicModel deleteInputBtn" width='800'>
            <operateLog v-if="logModal.flag" :operateItem='logModal.item'></operateLog>
        </Modal>
    </div>
</template>
<script>
    import Search from '@/components/search/search.vue';
    import matterManageApi from "@/api/matterManage";
    import action from  "./components/action.vue";
    import operateLog from './components/operateLog.vue'
    export default {
        data() {
            return {
                dataList: {/* 列表数据 */
                    records: []
                },
                searchParams: {/* 搜索参数 */
                    belongColumn:'',/* 所属栏目（0-商品推荐、1-营销素材） */
                    state:null,/* 状态 */
                    materialId:'',	/* 素材id */
                    title:'',	/* 标题 */
                    createdTimeStart:'',/* 创建起始时间 */
                    createdTimeEnd:'',/* 创建结束时间 */
                },
                logModal:{/* 日志弹框 */
                    flag:false,
                    item:'',
                },
                columnsList: [{/* 商品栏目类型 */
                        value: '',
                        label: '全部',
                    },
                    {
                        value: 0,
                        label: '商品推荐',
                    },
                    {
                        value: 1,
                        label: '营销素材'
                    }
                ],
                tableColumns: [{/* 表格 */
                        title: '素材 ID',
                        key: 'materialId',
                        align: "center",
                    }, {
                        title: '标题',
                        key: 'title',
                        align: "center",
                    },
                    {
                        title: '所属栏目',
                        key: 'belongColumnMap',
                        align: "center",
                    },
                    {
                        title: '创建时间',
                        key: 'createdTime',
                        align: "center",
                    },
                    {
                        title:'活动状态',
                        key: 'statedesc',
                        align: "center",
                        width: 180
                    },
                    // {
                    //     title:'商品状态',
                    //     key: '',
                    //     align: "center",
                    //     width: 180
                    // },
                    {
                        title: '操作',
                        key: '',
                        align: "center",
                        width: 280,
                        render:(h,params)=>{
                            return h(action,{
                                props:{
                                    row:params.row
                                },
                                on:{
                                    showMaterialsByCondition:()=>{
                                        this.showMaterialsByCondition()
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: '日志',
                        key: 'createdTime',
                        align: "center",
                        width: 90,
                        render:(h,params)=> {
                            return h('div',{
                                style:{
                                    'color':'#6236FF',
                                    'cursor':'pointer',
                                },
                                on:{
                                    click:()=>{
                                        this.logModal.flag=true;
                                        this.logModal.item=params.row
                                    }
                                }
                            },'查看')
                        },
                    },
                ],
                pageInfor:{
                    pageNo:1,
                    pageSize:10,
                },
                buttons:sessionStorage.getItem('menu'),/* 权限的按钮 */
            }
        },
        methods: {
            showMaterialsByCondition(){
                matterManageApi.showMaterialsByCondition(this.searchParams,this.pageInfor).then(res=>{
                    if(res.data.code=='200'){
                        if(res.data.data.records){
                            for(let i=0;i<res.data.data.records.length;i++){
                                res.data.data.records[i].belongColumnMap=res.data.data.records[i].belongColumn?'营销素材':'商品推荐'
                                res.data.data.records[i].createdTime=this.$tool.timeChange(res.data.data.records[i].createdTime)
                                switch(res.data.data.records[i].state){
                                    case 0:res.data.data.records[i].statedesc='未发布';break;
                                    case 1:res.data.data.records[i].statedesc='已发布';break;
                                    case 2:res.data.data.records[i].statedesc='待发布';break;
                                }
                            }
                            this.dataList=res.data.data
                        }else{
                            this.dataList.records.splice(0)
                        }
                    }else{
                        this.$Message.error(res.data.message)
                    }
                })
            },
            reset(){
                for(let item in this.searchParams){
                    item!='state'?this.searchParams[item]='':'';
                }
                this.showMaterialsByCondition()
            },
            pageChange(pageNo){
                this.pageInfor.pageNo=pageNo;
                this.$nextTick(()=>{
                    this.showMaterialsByCondition()
                })
            },
            pageSizeChange(pageSize){
                this.pageInfor.pageSize=pageSize;
                this.$nextTick(()=>{
                    this.showMaterialsByCondition()
                })
            }
        },
        activated() {
            this.showMaterialsByCondition()
        },
        components: {
            Search,
            action,
            operateLog
        }
    }
</script>
<style scoped>
    @import './index.css';
</style>